export default __webpack_public_path__ + "static/media/0000..0003.df3d95f8.png";